/* Note: This is an autogenerated file. Please DO NOT modify anything manually here. */
import * as Types from "src/generated/graph-api";

import { gql } from "@apollo/client";
export type GQLAccountSettingsTeamFieldsFragment = {
	__typename: "IdentityTeam";
	id: string;
	legalName: string | null;
	alias: string | null;
	name: string | null;
	logoUri: string | null;
	status: Types.GQLIdentityTeamStatus;
	supervisingBroker: {
		__typename: "IdentityBroker";
		id: string;
		license: {
			__typename: "IdentityLicense";
			id: string;
			number: string | null;
			state: {
				__typename: "IdentitySupportedState";
				code: Types.GQLIdentitySupportedStateCode;
			} | null;
		} | null;
	} | null;
};

export type GQLAccountSettingsHeaderFieldsFragment = {
	__typename: "IdentityUser";
	id: string;
	firstName: string | null;
	lastName: string | null;
	displayName: string | null;
	photoUrl: string | null;
	teamMemberships: Array<{
		__typename: "IdentityTeamMember";
		id: string;
		status: Types.GQLIdentityTeamMemberStatus | null;
		team: {
			__typename: "IdentityTeam";
			id: string;
			legalName: string | null;
			alias: string | null;
			name: string | null;
			logoUri: string | null;
			status: Types.GQLIdentityTeamStatus;
			supervisingBroker: {
				__typename: "IdentityBroker";
				id: string;
				license: {
					__typename: "IdentityLicense";
					id: string;
					number: string | null;
					state: {
						__typename: "IdentitySupportedState";
						code: Types.GQLIdentitySupportedStateCode;
					} | null;
				} | null;
			} | null;
		};
	} | null> | null;
};

export const AccountSettingsTeamFieldsFragmentDoc = gql`
    fragment AccountSettingsTeamFields on IdentityTeam {
  id
  legalName
  alias
  name
  logoUri
  status
  supervisingBroker {
    id
    license {
      id
      number
      state {
        code
      }
    }
  }
}
    `;
export const AccountSettingsHeaderFieldsFragmentDoc = gql`
    fragment AccountSettingsHeaderFields on IdentityUser {
  id
  firstName
  lastName
  displayName
  photoUrl
  teamMemberships {
    id
    status
    team {
      ...AccountSettingsTeamFields
    }
  }
}
    ${AccountSettingsTeamFieldsFragmentDoc}`;
